import { useDeepCompareEffect } from "@react-hookz/web";
import { useCallback, useState } from "react";

export const useIntersection = ({ root, rootMargin, threshold }: IntersectionObserverInit) => {
  const [intersection, setIntersection] = useState<IntersectionObserverEntry | null>(null);

  const [element, setElement] = useState<HTMLElement | null>(null);
  const [shouldDisable, setShouldDisable] = useState<boolean>(false);

  const captureIntersectionElement = useCallback((element: HTMLElement | null) => {
    setElement(element);
  }, []);

  useDeepCompareEffect(() => {
    if (shouldDisable || element === null || typeof IntersectionObserver !== "function")
      return () => {
        setIntersection(null);
      };

    const handler = (entries: IntersectionObserverEntry[]) => {
      setIntersection(entries[0]);
    };
    const observer = new IntersectionObserver(handler, {
      root,
      rootMargin,
      threshold,
    });
    observer.observe(element);
    return () => {
      setIntersection(null);
      observer.disconnect();
    };
  }, [element, root, rootMargin, threshold, shouldDisable]);

  return { captureIntersectionElement, element, intersection, setShouldDisable };
};
